<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>S1产测设置</span>
                </div>
            </div>
            <div class="btn_box">
                <div class="button button2 add" @click="addDislogShow" v-if="roleCheck('106-103-102-102')">
                    <i class="el-icon-plus"></i>
                    <span>新建</span>
                </div>
            </div>
            <el-table
                highlight-current-row
                :data="listData"
                style="width: 100%">
                <el-table-column prop="product" label="产品"></el-table-column>
                <el-table-column prop="config_key" label="规格"></el-table-column>
                <el-table-column prop="config_value" label="配置值"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope" >
                        <div>
                            <div class="button text" @click="updateDislogShow(scope.row)" v-if="roleCheck('106-103-102-102')">编辑</div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination> -->
            <Gh-Dialog ref="s1Setting" size="big" :title="dialog.title" @dialogBack="settingConfirm">
                <template v-slot:content>
                    <el-form label-width="100px" :model="actData" ref="addProductRule" :rules="formRule">
                        <el-form-item label="产品" prop="product">
                            <el-input v-model="actData.product" maxLength="32" placeholder="请输入产品"></el-input>
                        </el-form-item>
                        <el-form-item label="规格" prop="config_key">
                            <el-input v-model="actData.config_key" maxLength="32" placeholder="请输入配置键"></el-input>
                        </el-form-item>
                        <el-form-item label="配置值" prop="config_value">
                            <el-input v-model="actData.config_value" maxLength="32" placeholder="请输入配置值"></el-input>
                        </el-form-item>
                        
                    </el-form>
                </template>
            </Gh-Dialog>
        </div>
    </div>
</template>
<script>
export default({
    name: 's1-setting',
    data() {
        return {
            searchData: {
                page: 1,
                page_size: 10
            },
            dialog: {},
            actData: {},
            listData: [],
            total: 0,
            formRule: {
                product: [this.requiredRule('请输入机型代码')],
                config_key: [this.requiredRule('请输入规格')],
                config_value: [this.requiredRule('请输入配置值')],
            }
        }
    },
    watch: {
       
    },
    created() {
        this.getList();
    },
    methods: {
        getList() {
            this.api.ptGetS1Setting({}).then(data => {
                this.listData = data.data;
            })
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
            this.getList();
        },
        addDislogShow() {
            this.dialog = {
                title: '新增配置',
                type: 'add'
            };
            this.actData = {
                product: '',
                config_key: '',
                config_value: ''
            };
            this.$refs.s1Setting.show = true;
        },
        updateDislogShow(item) {
            this.dialog = {
                title: '修改配置',
                type: 'update'
            };
            this.actData = {
                id: item.Id,
                product: item.product,
                config_key: item.config_key,
                config_value: item.config_value
            };
            this.$refs.s1Setting.show = true;
        },
        settingConfirm() {
            if(this.dialog.type == 'add'){
                this.api.ptAddS1Setting(this.actData).then(data => {
                    this.actData = {};
                    this.$refs.s1Setting.show = false;
                    this.getList();
                })
            }else{
                this.api.ptUpdateS1Setting(this.actData).then(data => {
                    this.actData = {};
                    this.$refs.s1Setting.show = false;
                    this.getList();
                })
            }
            
        }
    }
})
</script>
<style lang="less" scoped>
    
</style>



// WEBPACK FOOTER //
// src/view/product-test-tool/s1/setting.vue